import axios from 'axios'
import moment from 'moment'
import {
  CLEAR_SALES_METRIC_ACTIVITIES,
  CLEAR_SALES_METRIC_CONTACTS,
  CLEAR_SALES_METRIC_PDF_DATA,
  GET_SALES_METRIC_PDF_DATA,
  GET_TABLE_DATA,
  SALES_METRIC_ACTIVITIES,
  SALES_METRIC_CONTACTS,
  SALES_METRIC_LOADING,
} from './types'

export const setLoading = (isLoading) => (dispatch) => {
  dispatch({ type: SALES_METRIC_LOADING, payload: isLoading })
}

export const getSalesMetricTableData = (options) => async (dispatch) => {
  try {
    const utcOffset = moment().utcOffset()
    dispatch(setLoading(true))

    const response = await axios.get('/reports/sales-metric', { params: { ...options, utcOffset } })
    dispatch({
      type: GET_TABLE_DATA,
      payload: response.data,
    })
    dispatch(setLoading(false))
  } catch (error) {
    dispatch(setLoading(false))
    throw new Error(error)
  }
}

export const getSalesMetricPDFData = (options) => async (dispatch) => {
  try {
    const opt = { ...options, pagination: { first: 0, limit: 1000 } }
    dispatch(setLoading(true))
    const response = await axios.get('/reports/sales-metric', { params: { ...opt } })
    dispatch({ type: GET_SALES_METRIC_PDF_DATA, payload: response.data })
    dispatch(setLoading(false))
  } catch (error) {
    dispatch(setLoading(false))
    throw new Error(error)
  }
}

export const clearSalesMetricPDFData = () => (dispatch) => {
  dispatch({ type: CLEAR_SALES_METRIC_PDF_DATA })
}

export const getContactsForSalesMetric = (options) => async (dispatch) => {
  try {
    const response = await axios.get(`/reports/sales-metric/contacts`, { params: { ...options } })
    dispatch({ type: SALES_METRIC_CONTACTS, payload: response.data })
  } catch (e) {
    throw new Error(e)
  }
}

export const clearSalesMetricContacts = () => (dispatch) => {
  dispatch({ type: CLEAR_SALES_METRIC_CONTACTS })
}

export const getActivitiesForSalesMetric = (options) => async (dispatch) => {
  try {
    const response = await axios.get('/activity/by-type', { params: { ...options } })
    dispatch({ type: SALES_METRIC_ACTIVITIES, payload: response.data })
  } catch (e) {
    throw new Error(e)
  }
}

export const clearSalesMetricActivities = () => (dispatch) => {
  dispatch({ type: CLEAR_SALES_METRIC_ACTIVITIES })
}
